import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateServiceById } from "../../../../redux/reducer/servicesReducer";
import ServicesRowDetails from "./ServicesRowDetails";
import EditServiceForm from "./EditServiceForm";

const ServicesTableDetails = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  setEditingOrder,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [editForm, setEditForm] = useState({
    nameEn: details.nameEN || "",
    nameAr: details.nameAR || "",
    descEN: details.descEN || "",
    descAR: details.descAR || "",
    image: null,
  });

  // console.log(details)
  const handleEdit = () => {
    // console.log("gtgtgt")
    setEditingOrder(details.id);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setEditForm((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const data = { ...editForm };

    try {
      setIsSubmitting(true); 
      await dispatch(updateServiceById({ id: details.id, data })).unwrap();
      onUpdate(); 
      setEditingOrder(null);
    } catch (err) {
      console.error("Failed to update Service", err);
    } finally {
      setIsSubmitting(false); 
    }
  };

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };

  // console.log(editForm)

  return (
    <>
      <ServicesRowDetails
        details={details}
        onDelete={onDelete}
        onEdit={handleEdit}
        getLinkButton={getLinkButton}
      />
      {isEditing && (
        <tr>
          <td colSpan="100%">
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
              <EditServiceForm
                editForm={editForm}
                onChange={handleEditChange}
                onFileChange={handleFileChange}
                onSubmit={handleEditSubmit}
                onCancel={() => setEditingOrder(null)}
                isLoading={isSubmitting}
              />
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default ServicesTableDetails;
